import React, { useState } from "react";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { PatientSearchModal } from "../modals/PatientSearchModal";
import { User } from "../../types/api";

interface LayoutProps {
    children: React.ReactNode;
    userName?: string;
    onLogout?: () => void;
    activeMenuItem?: string;
    onNavigate?: (item: "calendar" | "patients" | "tasks" | "internal-tasks" | "patient-page" | "patient" | "users" | "connections" | "billing" | "whatsapp" | "adhoc-meetings" | "ai-support", patientId?: string | number, meetingId?: string | number) => void;
    institutionId?: number;
    user?: User;
    taskCount?: number;
    whatsappUnreadCount?: number;
}

export const Layout: React.FC<LayoutProps> = ({
    children,
    userName,
    onLogout,
    activeMenuItem = "patients",
    onNavigate,
    institutionId = 0,
    user,
    taskCount,
    whatsappUnreadCount,
}) => {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    // Patient search lives in the header, so every screen wrapped by Layout gets it.
    const [isPatientSearchOpen, setIsPatientSearchOpen] = useState(false);

    return (
        <div style={{ height: "100vh", backgroundColor: "#f9fafb", display: "flex", flexDirection: "column", paddingTop: 60 }}>
            <Header
                userName={userName}
                onLogout={onLogout}
                taskCount={taskCount}
                onTaskClick={() => onNavigate?.("internal-tasks")}
                onSearchClick={user ? () => setIsPatientSearchOpen(true) : undefined}
            />
            <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>
                <Sidebar
                    isCollapsed={isSidebarCollapsed}
                    onToggle={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
                    activeItem={activeMenuItem}
                    onNavigate={onNavigate}
                    showPatientPage={activeMenuItem === "patient-page"}
                    institutionId={institutionId}
                    user={user}
                    taskCount={taskCount}
                    whatsappUnreadCount={whatsappUnreadCount}
                />
                <main
                    style={{
                        flex: 1,
                        marginTop: 0,
                        paddingTop: 2,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: isSidebarCollapsed ? 70 : 210,
                        overflow: "auto",
                        transition: "margin-left 0.3s ease",
                    }}
                >
                    {children}
                </main>
            </div>

            {user && (
                <PatientSearchModal
                    isOpen={isPatientSearchOpen}
                    onClose={() => setIsPatientSearchOpen(false)}
                    user={user}
                    onNavigate={onNavigate}
                />
            )}
        </div>
    );
};
